import { Field, ObjectType } from '@nestjs/graphql'
import { UserDto } from '../../user'
import { ReviewStatsDto } from './reviewStats'
import { UserAnalysisTeamDto } from './userAnalysisTeam.dto'

@ObjectType()
export class UserAnalysisDto {
  @Field(t => UserDto)
  user!: UserDto // TODO: Can this be BasicUserDto instead?

  @Field(t => ReviewStatsDto)
  stats!: ReviewStatsDto

  @Field(t => [UserAnalysisTeamDto])
  teams!: UserAnalysisTeamDto[]
}
